import React from "react";
import { motion } from "framer-motion";
import CardExperince from "../Card Education/CardExperince";
import babi from "../images/Babibai Enterprises - Visiting Card New Card 3.png";
import { Helmet } from "react-helmet-async";

const expeincearry = [
  {
    compnayname: "Quolam Business solution Pvt.Ltd",
    location: "Navi-Mumbai,Ghansoli",
    designation: "Software Enginner",
    discription:
      "",
    worktype: "Permanet",
    experince: "1.6+ years - present",
    skills: "node js, react js , express.js, javascript, mongodb,sql.S3,AWS, Tailwindcss, CSS3, Javascript,HTML,CSS",
    icon: "https://www.quolam.com/img/quolam-logo-favicon.png",
  },
  {
    compnayname: "Don Bosco",
    location: "Navi Mumbai,Nerul",
    designation: "Senior Software Developer",
    discription:
      "Work as an Fullstack Developer(MERN STACK). I had done all the backend work.Working in this project is more challening for me ",
    worktype: "Full-Time",
    experince: "5 Months... Present",
    skills:
      "React,Node.js,Taildwindcss,Express.js,Mongodb,S3 Bucket,Rought 53,AWS services",
    icon: "https://media.licdn.com/dms/image/C4E0BAQHjRwwilm0LLg/company-logo_200_200/0/1661782672391?e=1704326400&v=beta&t=pFdzHRse-Hxamm4OPUkzXQQKJNeolPfndmf0RbLPT_E",
  },
  {
    compnayname: "Boppo Technologies",
    location: "Navi Mumbai,Bhandup",
    designation: "Software Developer",
    discription:
      "Working as an Frontend Developer.Creating the Design and API'S Integration.New Development Done while working.",
    worktype: "Full-Time",
    experince: "9 Months",
    skills: "React,Material-UI,Redux,Redux-Saga",
    icon: "https://www.boppotechnologies.com/images/illustrator/BoppoLogo.svg",
  },
  {
    compnayname: "Babibai Enterprises",
    location: "Mumbai,Thane",
    designation: "Operations Associate",
    discription:
      " Handeling the all over the opertaion of compnay with Managing the data.Data migration alos done that.Some part of the Billing process setup. ",
    worktype: "Full-Time",
    experince: "3 Years. 7 Months",
    skills: "SQL,HTML,CSS,Excel,Hadoop,R",
    icon: babi,
  },
  {
    compnayname: "Environ Green Care",
    location: "Mumbai,Thane",
    designation: "Intern",
    discription:
      "Expedited procurement of raw materials by preparing bills and purchase orders while maintaining an easy accessibility of documents by appropriately sorting and filing them",
    worktype: "Internship",
    experince: "3 Months",
    skills: "SQL,Excel",
    icon: "https://m.imimg.com/gifs/img/cIcon.png",
  },
];

const PageTransion = {
  in: {
    opacity: 1,
    y: 0,
  },
  out: {
    opacity: 0,
    y: "-100%",
  },
};
const Experince = () => {
  return (
    <div>
      <motion.div
        animate="in"
        initial="out"
        exit="out"
        variants={PageTransion}
        className="flex px-8 mb-6 lg:px-16 lg:min-h-[70vh]"
      >

        <Helmet>
          <title>About Us – https://abhishek-bhoir.vercel.app/</title>

          <meta
            name="description"
            content="backend,frontend, 3 years of experince in frontend, backend, node js, react js , express.js, expres, javascript, mongodb,sql."
          />

          <link rel="canonical" href="https://abhishek-bhoir.vercel.app/experince" />

          <meta property="og:title" content="About Us – Plannity.in" />
          <meta
            property="og:description"
            content="backend,frontend, 3 years of experince in frontend, backend, node js, react js , express.js, expres, javascript, mongodb,sql."
          />
          <meta property="og:url" content="https://abhishek-bhoir.vercel.app/experince" />

        </Helmet>
        <div className="grid lg:grid-cols-2 gap-4 lg:mr-36 ">
          {expeincearry.map((item, index) => (
            <>
              <CardExperince
                key={index}
                compnayname={item.compnayname}
                location={item.location}
                designation={item.designation}
                discription={item.discription}
                worktype={item.worktype}
                experince={item.experince}
                skills={item.skills}
                icon={item.icon}
              />
            </>
          ))}
        </div>
      </motion.div>
    </div>
  );
};

export default Experince;
